import { z } from 'zod'

import { DateZod } from '../../../common'

export const PiloteTeamTypeZod = z.enum(['STANDARD', 'VIP', 'ORGANIZATION'])
export const PiloteTeamMobileOperatorZod = z.enum(['PARTNER', 'ESCORT', 'DRIVER'])

export const PiloteTeamRecordZod = z.object({
  id: z.number(),
  central_id: z.number(),
  campaign_id: z.number(),
  evening_id: z.number().nullable(),
  number: z.number().nullable(),
  status: z.number(),
  type: PiloteTeamTypeZod,
  is_vehicle_electrical: z.boolean(),
  is_manual: z.boolean(),
  radio_base: z.string().nullable(),
  use_radio: z.boolean(),
  use_mobile_phone: z.boolean(),
  use_phone_cabin: z.boolean(),
  use_amateur_radio: z.boolean(),
  use_mobile_application: z.boolean(),
  mobile_operator: PiloteTeamMobileOperatorZod,
  vehicle_mileage_start: z.number().nullable(),
  vehicle_mileage_end: z.number().nullable(),
  version: z.number().optional().default(0),
  in_return_since: DateZod.nullable(),
  is_assisted_assignment_enabled: z.boolean(),
  available_at_institution_id: z.number().nullable(),
  available_at_location_id: z.number().nullable(),
  available_at_region_id: z.number().nullable(),
  uuid: z.string(),
})
